(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('externalDocuments', {
            parent: 'external',
            url: '/external/documents?hash',
            data: {
                authorities: [],
                pageTitle: 'eDocumentsApp.document.home.title'
            },
            views: {
                'main@': {
                    templateUrl: 'app/external/document/documents.external.html',
                    controller: 'DocumentsExternalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
